export default "__VITE_ASSET__4qCyvBGq__"